<script setup>
  defineProps({
    items: {
      type: Array,
      required: true
    }
  });
</script>

<template>
  <ol class="ml-12 list-inside list-decimal p-4">
    <li v-for="(item, index) in items" :key="index" class="mb-2">
      {{ item }}
    </li>
  </ol>
</template>
